import "@/App.css";
import "@/app-shell.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Privacidad from "@/pages/Privacidad";
import PagoCancelado from "@/pages/PagoCancelado";
import Login from "@/pages/auth/Login";
import Registro from "@/pages/auth/Registro";
import ClientDashboard from "@/pages/cliente/Dashboard";
import Beneficiarios from "@/pages/cliente/Beneficiarios";
import SolicitarAsistencia from "@/pages/cliente/SolicitarAsistencia";
import Historial from "@/pages/cliente/Historial";
import MiPlan from "@/pages/cliente/MiPlan";
import Referidos from "@/pages/cliente/Referidos";
import Salud from "@/pages/cliente/Salud";
import Onboarding from "@/pages/cliente/Onboarding";
import PagoExito from "@/pages/cliente/PagoExito";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminMiembros from "@/pages/admin/Miembros";
import AdminSolicitudes from "@/pages/admin/Solicitudes";
import AdminAudit from "@/pages/admin/Audit";
import AdminWhatsapp from "@/pages/admin/Whatsapp";
import AdminSecurity from "@/pages/admin/Security";
import AuthCallback from "@/pages/auth/AuthCallback";
import { RouteTracker } from "@/lib/analytics";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/pago/cancelado" element={<PagoCancelado />} />
            <Route path="/cuenta/login" element={<Login />} />
            <Route path="/cuenta/registro" element={<Registro />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route path="/cuenta" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
            <Route path="/cuenta/beneficiarios" element={<ProtectedRoute><Beneficiarios /></ProtectedRoute>} />
            <Route path="/cuenta/solicitar" element={<ProtectedRoute><SolicitarAsistencia /></ProtectedRoute>} />
            <Route path="/cuenta/historial" element={<ProtectedRoute><Historial /></ProtectedRoute>} />
            <Route path="/cuenta/plan" element={<ProtectedRoute><MiPlan /></ProtectedRoute>} />
            <Route path="/cuenta/referidos" element={<ProtectedRoute><Referidos /></ProtectedRoute>} />
            <Route path="/cuenta/salud" element={<ProtectedRoute><Salud /></ProtectedRoute>} />
            <Route path="/cuenta/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/cuenta/pago/exito" element={<ProtectedRoute><PagoExito /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute requireRole="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/miembros" element={<ProtectedRoute requireRole="admin"><AdminMiembros /></ProtectedRoute>} />
            <Route path="/admin/solicitudes" element={<ProtectedRoute requireRole="admin"><AdminSolicitudes /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute requireRole="admin"><AdminAudit /></ProtectedRoute>} />
            <Route path="/admin/whatsapp" element={<ProtectedRoute requireRole="admin"><AdminWhatsapp /></ProtectedRoute>} />
            <Route path="/admin/security" element={<ProtectedRoute requireRole="admin"><AdminSecurity /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <PwaInstallPrompt />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
